// SPDX-FileCopyrightText: Copyright Orangebot, Inc. and Medplum contributors
// SPDX-License-Identifier: Apache-2.0

// Canonical treatment-status / CarePlan constants. Kept because the workflow engine
// (apply-plan-definition) and patient-app useTreatmentPlan still depend on them; the
// drifted provider-app copy was removed in SLE-660.

/** System URL for treatment funnel status codes */
export const TREATMENT_STATUS_SYSTEM = 'http://polarissleep.com/treatment-status';

/** System URL for care plan categories */
export const CAREPLAN_CATEGORY_SYSTEM = 'http://polarissleep.com/careplan-category';

/** Extension URL for next action */
export const NEXT_ACTION_EXTENSION_URL = 'http://polarissleep.com/next-action';

/** Extension URL for opt-out */
export const OPT_OUT_EXTENSION_URL = 'http://polarissleep.com/opt-out';

export const TREATMENT_STATUSES = [
  { code: 'triage', display: 'Triage' },
  { code: 'hsat-ordered', display: 'HSAT Ordered' },
  { code: 'in-lab-required', display: 'In-Lab Required' },
  { code: 'hsat-delivered', display: 'HSAT Delivered' },
  { code: 'hsat-completed', display: 'HSAT Completed' },
  { code: 'hsat-results-received', display: 'HSAT Results Received' },
  { code: 'first-appointment-scheduled', display: 'First Appointment Scheduled' },
  { code: 'first-appointment-completed', display: 'First Appointment Completed' },
  // Follow-up stages (mapped from care journey triage statuses)
  { code: 'followup-30', display: 'Follow-up 30-Day' },
  { code: 'followup-90', display: 'Follow-up 90-Day' },
  { code: 'followup-180', display: 'Follow-up 180-Day' },
  { code: 'annual-followup', display: 'Annual Follow-up' },
  { code: 'non-adherent', display: 'Non-Adherent' },
] as const;

export type TreatmentStatusCode = (typeof TREATMENT_STATUSES)[number]['code'];
